// extracted by mini-css-extract-plugin
export default {"hero":"Hero4_hero__mcsDw","images":"Hero4_images__GUwDP","image":"Hero4_image__nRfHd","textOverlay":"Hero4_textOverlay__qFwzJ","title":"Hero4_title__ubJ8F"};